import { DeviceDto } from "@/api/query.schemas";
import { isCoreV3Device } from "@/utils/isCoreV3Device";

export const isLoadManagementQualifyingCore = (device: DeviceDto) =>
    !device.passthroughConfigId &&
    (!device.fwVersion || isCoreV3Device(device));
